import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link';

const Navbar = () => {
  const [openNav, setOpenNav] = useState(false)
  const [openTransition, setOpenTransition] = useState(false)

  const onClickOpen = async () => {
    setOpenTransition(!openTransition)
    if (openNav === true) {
      setTimeout(() => {
        // Set open transition to false again, 
        // So it won't have a flip condition bug.
        setOpenTransition(false)
        setOpenNav(false)
      }, 400);
    } else {
      setOpenNav(true)
    }
  }

  return (
    <nav className='
                sticky top-0 z-20 
                bg-[#FFFDFA] text-[#181A18] 
                md:shadow-[0px_2px_4px_2px_rgba(0,0,0,0.03)] 
                rounded-[8px]'>

      {/* Getsemani and 3 Striped Menu */}
      <div className='flex items-center
                px-6 py-6 shadow-[0px_2px_4px_2px_rgba(0,0,0,0.03)] rounded-[12px]
                md:float-left md:shadow-none md:rounded-none'>
        <h1><b>Getsemani</b> Luggage Storage</h1>
        <button className='flex md:hidden rounded ml-auto' onClick={() => { onClickOpen() }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 15H17.5V13.3333H2.5V15ZM2.5 10.8333H17.5V9.16667H2.5V10.8333ZM2.5 5V6.66667H17.5V5H2.5Z" fill="#181A18" />
          </svg>
        </button>
      </div>

      {/* Navigation Panel */}
      <div id='nav_panel' className={`${openNav ? "block" : "hidden"} ${openTransition ? "fadein" : "fadeout"} absolute w-full md:w-auto md:static md:block md:float-right py-6 pr-6 md:py-6 pl-6 md:pl-auto 
        shadow-[0px_2px_4px_2px_rgba(0,0,0,0.03)] 
        md:shadow-none bg-[#FFFDFA]`}>
        <ul className='flex flex-col md:flex-row' onClick={() => { onClickOpen() }}>
          <Link smooth to='/#header' className='cursor-pointer'>
            <li className='pl-4 md:mr-4 py-2 md:p-0 rounded-[8px] hover:bg-[#F0F0F0]'>Home</li>
          </Link>
          <Link smooth to='/#steps' className='cursor-pointer'>
            <li className='pl-4 md:mr-4 py-2 md:p-0 rounded-[8px] bg-[#FAFAFA] md:bg-inherit hover:bg-[#F0F0F0]'>Steps</li>
          </Link>
          <Link smooth to='/#facilities' className='cursor-pointer'>
            <li className='pl-4 md:mr-4 py-2 md:p-0 rounded-[8px] hover:bg-[#F0F0F0]'>Facilities</li>
          </Link>
          <Link smooth to='/#faq' className='cursor-pointer'>
            <li className='pl-4 md:mr-4 py-2 md:p-0 rounded-[8px] bg-[#FAFAFA] md:bg-inherit hover:bg-[#F0F0F0]'>FAQ</li>
          </Link>
          <Link smooth to='/#footer' className='cursor-pointer'>
            <li className='pl-4 md:mr-4 py-2 md:p-0 rounded-[8px] hover:bg-[#F0F0F0]'>Contact</li>
          </Link>
          <Link smooth to='/rates#header' className='cursor-pointer'>
            <li className='pl-4 md:mr-4 py-2 md:p-0 rounded-[8px] bg-[#FAFAFA] md:bg-inherit hover:bg-[#F0F0F0] text-blue-600 pointer'>Rates</li>
          </Link>
        </ul>
      </div>
      <div className='clear-both'></div>
    </nav>
  )
}

export default Navbar